import { CaseAssignedVia } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const caseAssignedViaMessages = defineMessages({
  conversationPicker: {
    defaultMessage: 'Operator holding the conversation',
    description: 'case assigned-via rung',
  },
  engagement: {
    defaultMessage: "Customer's relationship holder",
    description: 'case assigned-via rung',
  },
  manual: {
    defaultMessage: 'Chosen by a person',
    description: 'case assigned-via rung',
  },
  pool: {
    defaultMessage: 'Round-robin pool',
    description: 'case assigned-via rung',
  },
  reserved: {
    defaultMessage: 'Reserved before outreach',
    description: 'case assigned-via rung',
  },
  similarity: {
    defaultMessage: 'Similar case (same customer or suspected duplicate)',
    description: 'case assigned-via rung',
  },
})

export function translateCaseAssignedVia(intl: IntlShape, via: CaseAssignedVia): string {
  switch (via) {
    case CaseAssignedVia.CONVERSATION_PICKER:
      return intl.formatMessage(caseAssignedViaMessages.conversationPicker)
    case CaseAssignedVia.ENGAGEMENT:
      return intl.formatMessage(caseAssignedViaMessages.engagement)
    case CaseAssignedVia.MANUAL:
      return intl.formatMessage(caseAssignedViaMessages.manual)
    case CaseAssignedVia.POOL:
      return intl.formatMessage(caseAssignedViaMessages.pool)
    case CaseAssignedVia.RESERVED:
      return intl.formatMessage(caseAssignedViaMessages.reserved)
    case CaseAssignedVia.SIMILARITY:
      return intl.formatMessage(caseAssignedViaMessages.similarity)
  }
}
